//@flow
import styled, { css } from "styled-components"
import { mqMax } from "common/mediaQuery"
import { lighten } from "global/theme"

export const ConfirmWrap = styled.div`
    margin-top: 3rem;
    margin-bottom: 3rem;
`
export const ConfirmationWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 5rem;
`

export const Verification = styled.div`
    max-width: 68rem;
    padding-top: 2rem
`

export const VerificationOptions = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    padding-top: 2rem;
    padding-bottom: 2rem;
    min-width: 45rem;

    ${mqMax.tabletWide} {
        flex-direction: column;
        align-items: stretch;
        min-height: 16rem;
        min-width: auto;
    }
`
export const VerificationCode = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

export const VerificationCodeInput = styled.input`
  height: 5rem;
  border: solid 0.1rem ${(props) => props.theme.color.lightGray};
  color: ${(props) => props.theme.color.secondaryText};
  border-radius: 0.4rem;
  background: ${(props) => props.theme.color.white};
  padding: 0 1.7rem;
  font-size: 1.8rem;
  font-weight: ${(props) => props.theme.fontWeights.normal};
  width: 16rem;
  letter-spacing: 1rem;
  outline: none;
  opacity: 1;
  -webkit-appearance: none;
  -moz-appearance: textfield;
  position: relative;
  padding-right: 0.5rem;
  text-align: center;

  &:focus {
    border-color: ${(props) => props.theme.color.primaryAccent};
    z-index: ${(props) => props.theme.zIndices.minimal};
  }

  &::placeholder {
    color: ${(props) => lighten(
      props.theme.color.secondaryText,
      0.5,
    )};
  }

  ::-webkit-search-cancel-button,
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  ${p => p.left &&
  css`
      width: 50%;
      border-radius: 0.4rem 0 0 0.4rem;
      margin-right: -0.2rem;
    `}
  ${p => p.right &&
  css`
      width: 50%;
      border-radius: 0 0.4rem 0.4rem 0;
    `}
`;



// WEBPACK FOOTER //
// ./src/pages/AffiliateRegistration/Confirm/styled.js